export const FETCH_AUDIT_LOGS_REQUEST = 'auditLogs/FETCH_AUDIT_LOGS_REQUEST'
export const FETCH_AUDIT_LOGS_SUCCESS = 'auditLogs/FETCH_AUDIT_LOGS_SUCCESS'
export const FETCH_AUDIT_LOGS_FAILURE = 'auditLogs/FETCH_AUDIT_LOGS_FAILURE'

export const FETCH_AUDIT_LOG_INFO_REQUEST =
  'auditLogs/FETCH_AUDIT_LOG_INFO_REQUEST'
export const FETCH_AUDIT_LOG_INFO_SUCCESS =
  'auditLogs/FETCH_AUDIT_LOG_INFO_SUCCESS'
export const FETCH_AUDIT_LOG_INFO_FAILURE =
  'auditLogs/FETCH_AUDIT_LOG_INFO_FAILURE'

export const EXPORT_AUDIT_LOGS_REQUEST = 'auditLogs/EXPORT_AUDIT_LOGS_REQUEST'
export const EXPORT_AUDIT_LOGS_SUCCESS = 'auditLogs/EXPORT_AUDIT_LOGS_SUCCESS'
export const EXPORT_AUDIT_LOGS_FAILURE = 'auditLogs/EXPORT_AUDIT_LOGS_FAILURE'

export const UPDATE_FIELD = 'auditLogs/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'auditLogs/SET_DEFAULT_DATA'
